import cx from "classnames/dedupe";
import React, { useCallback, useRef, useState } from "react";
import { useForm } from "../../hooks/useForm";
import { useValidation, VALIDATION_STATE, } from "../../hooks/useValidation";
import { InputErrorList } from "./InputErrorList";
import { InputIcon } from "./InputIcon";
import { EmailSuggestion, isPotentialMisspelling } from "./EmailSuggestion";
export const EmailInput = React.forwardRef(({ value = "", onChange, onBlur, label, name = "email", autoComplete = "email", placeholder, disabled = false, forceValidation = false, readOnly = false, suggestionMessage, validators, "data-test-id": dataTestId, showPendingState = false, showSuccessState = false, }, ref) => {
    const inputId = useRef("email_" + Math.random().toString(36).substr(2, 9));
    const containerRef = useRef(null);
    const [validity, errorMessages, validityClasses, resetValidation] = useValidation(value, validators, forceValidation, showPendingState, showSuccessState);
    useForm(inputId.current, validity, value, resetValidation, containerRef, errorMessages, label);
    const [dismissedSuggestion, setDismissedSuggestion] = useState(false);
    const onBlurCallback = useCallback(() => {
        onBlur && onBlur();
    }, [onBlur]);
    const warn = suggestionMessage &&
        !dismissedSuggestion &&
        isPotentialMisspelling(value);
    const isValidating = validators && validators.length > 0;
    const isSuccessValidation = validity === VALIDATION_STATE.SUCCESS;
    const classes = cx("lysa-ui-input", validityClasses, {
        "lysa-ui-input-read-only": readOnly,
        "lysa-ui-input-warning": warn && (!isValidating || isSuccessValidation),
        "lysa-ui-input-valid": !warn && isSuccessValidation && showSuccessState,
    });
    return (React.createElement("div", { ref: containerRef, className: "lysa-ui-input-group", "data-test-id": dataTestId },
        React.createElement("label", { htmlFor: inputId.current }, label),
        React.createElement("div", { className: classes },
            React.createElement("input", { type: "email", id: inputId.current, name: name, autoComplete: autoComplete, value: value, placeholder: placeholder, onChange: (event) => {
                    onChange(event.target.value);
                    setDismissedSuggestion(false);
                }, disabled: disabled, onBlur: onBlurCallback, readOnly: readOnly, ref: ref }),
            React.createElement(InputIcon, null),
            validity !== VALIDATION_STATE.PENDING &&
                !dismissedSuggestion &&
                suggestionMessage && (React.createElement(EmailSuggestion, { email: value, msg: suggestionMessage, setEmail: onChange, dismiss: () => setDismissedSuggestion(true) })),
            React.createElement(InputErrorList, { errorMessages: errorMessages }))));
});
